import Controller from './controller'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

export default class extends Controller {
  static get targets() {
    return ['item']
  }

  initialize() {
    this.count = this.itemTargets.length

    gsap.to(this.element, {
      scrollTrigger: {
        trigger: this.element,
        start: "top center+=30%",
        end: "top+="+window.innerHeight/2+" center",
        scrub: 0.5,
        // markers: true,
        onUpdate: (self) => {
          let starter = Math.ceil(self.progress * this.count) - 1
          let index = starter < 0 ? 0 : starter
              
          for (var i = 0; i < this.itemTargets.length; i++) {
            if (i <= index) {
              this.itemTargets[i].classList.add('is-active')
            } else {
              this.itemTargets[i].classList.remove('is-active')
            }
          }
    
          if (starter == -1) {
            this.itemTargets[0].classList.remove('is-active')
          }
        }
      }
    })
  }
}
